export default customElements.define('w-progress-diagram', class ProgressBar extends wealthify.CustomElementBaseClass {
    constructor() {
        const styleSelector = 'c-progress-diagram';
        const config = {
            styleSelector,
            templateHTML: `
            <div class="${styleSelector}__container" data-root>
                <div class="${styleSelector}__step-container" data-stepscontainer></div>
                <div class="${styleSelector}__step-line u-display__none--mobile" data-stepsline></div>
            </div>`,
            cacheDom: ['data-stepscontainer', 'data-stepsline']
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get requiredProperties() {
        return ['icon', 'titleprop'];
    }

    static get observedProps() {
        return [
            new wealthify.Prop('steps', {
                type: wealthify.propTypes.Array(),
                validators: [wealthify.propValidators.ArrayObjectContainsKeys(this.requiredProperties), wealthify.propValidators.ArrayHasMinimumLength(2)],

            }),
        ];
    }

    get propCallbacks() {
        return {steps: () => {
            this._buildSteps();
            this._updateStepLine();
            this._addArrows();
        }};
    }

    _buildSteps() {
        this.dom.stepscontainer.innerHTML = '';

        this.steps.forEach((step) => {
            const divTag = document.createElement('div');
            const iconTag = document.createElement('w-icon');
            const titleTag = document.createElement('div');
            const descriptionTag = document.createElement('p');
            
            divTag.classList.add(`${this.styleSelector}__step`);
            iconTag.type = step.icon;
            iconTag.classList.add(`${this.styleSelector}__icon`);
            titleTag.innerHTML = step.titleprop;
            titleTag.classList.add(`${this.styleSelector}__title`);
            descriptionTag.innerHTML = step.description;
            descriptionTag.classList.add(`${this.styleSelector}__description`);
            
            divTag.appendChild(iconTag);
            divTag.appendChild(titleTag);
            divTag.appendChild(descriptionTag);

            this.dom.stepscontainer.appendChild(divTag);
        });
    }

    _updateStepLine() {
        const lineOffset = (100 / this.steps.length) / 2;

        this.dom.stepsline.style.left = `${lineOffset}%`;
        this.dom.stepsline.style.right = `${lineOffset}%`;
    }

    _addArrows() {
        this.dom.stepsline.innerHTML = '';

        const arrowCount = this.steps.length - 1;
        const segmentLength = 100 / arrowCount;

        for (let index = 0; index < arrowCount; index++) {
            const arrow = document.createElement('w-icon');

            arrow.type = 'caret-forward-bevel';
            arrow.classList.add(`${this.styleSelector}__step-arrow`);
            arrow.style.left = `${(index * segmentLength) + (segmentLength / 2)}%`;
            
            this.dom.stepsline.appendChild(arrow);
        }
    }
});